export default __webpack_public_path__ + "static/media/helpful-resources-page--tablet.0783e44e.webp";